//import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import CustomAnimation from "src/scripts/animation/customAnimation";

const customAnmation = new CustomAnimation();

class Home {
  init() {
    this.initParallax();
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header');

    customAnmation.animateFromBottom('.animate_from_bottom');

    customAnmation.animateButtonGroup('.intro_button_holder a');

    customAnmation.animateButtonGroup('.intro_logo');
  }
}

export default Home;
